import { getSections, getSectionContent } from '@/api/sections';
import { ContentTypes } from '@/constants/linkContent';
import sectionCategories from '@/utils/sectionCategories';

import taggedContent from '@/store/modules/sections/tagged-content';

export default {
  namespaced: true,
  modules: {
    taggedContent,
  },
  state: {
    sections: [],
    content: [],
    activeType: ContentTypes.EVERYTHING,
    activeSectionId: null,
    isLoadingSections: false,
    isLoadingSectionContent: false,
    isLoadingMoreSectionContent: false,
    hasMoreSectionContent: true,
    page: 1,
  },
  mutations: {
    setSections(state, sections) {
      state.sections = sections;
    },
    setActiveSectionId(state, sectionId) {
      state.activeSectionId = sectionId;
      state.hasMoreSectionContent = true;
      state.page = 1;
    },
    setSectionContent(state, content) {
      state.content = content;
    },
    setSectionsLoadingState(state, isLoading) {
      state.isLoadingSections = isLoading;
    },
    setSectionsContentLoadingState(state, isLoading) {
      state.isLoadingSectionContent = isLoading;
    },
    resetPagination(state) {
      state.hasMoreSectionContent = true;
      state.page = 1;
    },
  },
  actions: {
    async loadSections({ commit }) {
      try {
        commit('setSectionsLoadingState', true);

        const { data } = await getSections();
        const [section] = data;

        commit('setSections', data);
        commit('setActiveSectionId', section.id);
      } finally {
        commit('setSectionsLoadingState', false);
      }
    },
    async loadSectionContent({ commit, state }) {
      try {
        commit('setSectionsContentLoadingState', true);

        const { data } = await getSectionContent({
          sectionId: state.activeSectionId,
          type: state.activeType,
        });

        commit('setSectionContent', data);
      } catch (e) {
        commit('setSectionContent', []);
        console.error(e);
      } finally {
        commit('setSectionsContentLoadingState', false);
      }
    },
  },
  getters: {
    sections: state => state.sections || [],
    sectionById: state => id => state.sections.find(section => section.id === id) || {},
    hasMoreSectionContent: state => state.hasMoreSectionContent,
    featuredSections: state => state.sections
      .filter(section => section.category === sectionCategories.FEATURED),
    cuisineSections: state => state.sections
      .filter(section => section.category === sectionCategories.CUISINE),
    reviewsAndGuidesSections: state => state.sections
      .filter(section => section.category === sectionCategories.REVIEWS_AND_GUIDES),
  },
};
